export default import.meta.ROLLUP_FILE_URL_oSk01kmRmW5dLE9wA6No8Q